import styled from '@mui/material/styles/styled'
import Tab from '@mui/material/Tab'

export const TabStyled = styled(Tab, {
  name: 'TabStyled',
  shouldForwardProp: (prop) => prop !== 'color',
})(({ color }) => ({
  minWidth: '178px',
  fontFamily: 'Source Sans Pro Semibold',
  color,
}))
